import { jsx as _jsx } from "react/jsx-runtime";
import { Icon, List } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import styles from './instrumentInsightsPrompts.module.scss';
export const InstrumentInsightsPrompts = ({ prompts, onSelectPrompt, }) => {
    return (_jsx(List, Object.assign({ className: styles.list }, { children: prompts.map((prompt) => {
            var _a;
            return (_jsx(List.Item, { className: styles.listItem, variant: "large", title: prompt.title, titleSecondary: prompt.description, contentLeft: _jsx(Icon, { name: (_a = prompt.icon) !== null && _a !== void 0 ? _a : 'ai', color: colors.purple[700], size: 24, className: styles.icon }), onClick: () => onSelectPrompt(prompt) }, prompt.id));
        }) })));
};
